import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { getAllLocations, getLocationAction, LocationChangeStatusAction, insertUpdateLocationAction } from "../actions/locationActions";
const INITIAL_STATE = {
    locations: {
        data: {
            records: [],
            totalRecords: 0,
        },
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    selectedLocation: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },


    insertUpdateDetails: {
        data: {},

        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    },
    changeStatusDetails: {
        data: {},

        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    },

}

const locationReducer = createSlice({
    name: "locationData",
    initialState: INITIAL_STATE,
    reducers: {
        RESET(state, action) {
            state = INITIAL_STATE;
        },
        ResetLocationDetailsState(state, action) {
            state.selectedLocation = INITIAL_STATE.selectedLocation;
            state.insertUpdateDetails = INITIAL_STATE.insertUpdateDetails;
        },


    },
    extraReducers: (builder) => {

        //  --------getAllLocations start--------------------

        builder.addCase(getAllLocations.fulfilled, (state, action) => {

            state.locations.data.records = action.payload.data;
            state.locations.apiMsg.status = action.meta.requestStatus;
            state.locations.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(getAllLocations.pending, (state, action) => {

            state.locations.data.records = null;
            state.locations.apiMsg.message = action.meta.requestStatus;;
            state.locations.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getAllLocations.rejected, (state, action) => {

            state.locations.apiMsg.message = action.error.message;
            state.locations.apiMsg.status = action.meta.requestStatus;
        });

        //  -------- getAllLocations Action end--------------------

        //   getLocation start

        builder.addCase(getLocationAction.fulfilled, (state, action) => {
            state.selectedLocation.data = action.payload.data
            state.selectedLocation.apiMsg.status = action.meta.requestStatus;
            state.selectedLocation.apiMsg.message = action.payload.message.message;
        });

        builder.addCase(getLocationAction.pending, (state, action) => {
            state.selectedLocation.data = null;
            state.selectedLocation.apiMsg.message = action.meta.requestStatus;;
            state.selectedLocation.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(getLocationAction.rejected, (state, action) => {
            state.selectedLocation.apiMsg.message = action.error.message;
            state.selectedLocation.apiMsg.status = action.meta.requestStatus;
        });


        //   getlocation end



        // insertUpdateCenterAction start

        builder.addCase(
            insertUpdateLocationAction.fulfilled,
            (state, action) => {

                state.insertUpdateDetails.data = action.payload.data.data;
                state.insertUpdateDetails.apiMsg.status = action.meta.requestStatus;
                state.insertUpdateDetails.apiMsg.message = action.payload.message.message;



                if (action.payload.newRecord) {


                    if (state.locations.data.records.length) {
                        state.locations.data.records.unshift(action.payload.data.data);
                    }
                    else {
                        state.locations.data.records.push(action.payload.data.data);
                    }
                }
                toast.success(action.payload.message.message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    toastId: "client-error"
                });

            }
        );
        builder.addCase(
            insertUpdateLocationAction.pending,
            (state, action) => {
                state.insertUpdateDetails.apiMsg.status = action.meta.requestStatus;
            }
        );
        builder.addCase(
            insertUpdateLocationAction.rejected,
            (state, action) => {

                state.insertUpdateDetails.apiMsg.message = action.error.message;
                state.insertUpdateDetails.apiMsg.status = action.meta.requestStatus;

                toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    toastId: "dept-error"
                });
            }
        );


        //   insert update location action end

        //------------------------------- changeStatusAction start -------------------------

        builder.addCase(
            LocationChangeStatusAction.fulfilled,
            (state, action) => {
                console.log("changeStatusAction", action);

                state.changeStatusDetails.data = action.payload.data;
                state.changeStatusDetails.apiMsg.status = action.meta.requestStatus;
                state.changeStatusDetails.apiMsg.message = action.payload.message.message;

                let updatedRecord = state.locations.data.records.map(x => {
                    if (x.id == action.meta.arg.id) {
                        x.isActive = state.changeStatusDetails.data.isActive;
                        return x;
                    }
                    else {
                        return x;
                    }
                })



                state.locations.data.records = updatedRecord;

                toast.success(action.payload.message.message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    toastId: "success"
                });

            }
        );
        builder.addCase(
            LocationChangeStatusAction.pending,
            (state, action) => {
                state.changeStatusDetails.apiMsg.status = action.meta.requestStatus;
            }
        );
        builder.addCase(
            LocationChangeStatusAction.rejected,
            (state, action) => {
                state.changeStatusDetails.apiMsg.message = action.error.message;
                state.changeStatusDetails.apiMsg.status = action.meta.requestStatus;

                toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    toastId: "error"
                });
            }
        );




    },
});
export const { RESET, ResetLocationDetailsState } = locationReducer.actions;
export default locationReducer.reducer;